import React, { useState } from 'react';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleQuestion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "What is Digital Wardrobe?",
            answer: "Digital Wardrobe is an online platform that helps you manage your outfits, travel lists, and occasions with ease. You can keep track of your clothing items, plan outfits for trips, and manage your wardrobe efficiently."
        },
        {
            question: "How can I upload clothes to my wardrobe?",
            answer: "Simply navigate to the 'Clothes' section, click 'Upload', and fill in the details of the clothing item you wish to upload. And don't forget to add an image to it!"
        },
        {
            question: "How can I create an outfit?",
            answer: "Simply navigate to the 'Outfits' section, click 'Create', and select clothing items from your wardrobe. You can name your outfit, add details, and even plan it for specific occasions."
        },
        {
            question: "Can I add clothes to an outfit after it's been created?",
            answer: "Yes, of course you can edit outfits at any time by going to the 'Outfits' section, selecting the outfit you wish to edit by clicking on 'Edit', and adding or removing items."
        },
        {
            question: "Can I add or remove outfits from an occasion?",
            answer: "Yes, you can add or remove outfits from occasions at any time by going to the 'Occasions' section, selecting the occasion you wish to edit by clicking on 'Edit', and adding or removing items."
        },
        {
            question: "What are travel lists?",
            answer: "Travel lists help you prepare clothing items for specific trips. You can create packing lists for any trip, including departure and return dates, destinations, and a small description about your upcoming trip."
        },
        {
            question: "Is there a way I can view my account and possibly delete it?",
            answer: "Through the 'My Account' section you can view your profile, edit your details but also delete your account if you wish to, by clicking on 'Delete' button!"
        },
        {
            question: "How do I subscribe to your newsletter?",
            answer: "You can subscribe to our newsletter by entering your email address in the subscription box found in the footer of our website."
        },
        {
            question: "How can I contact customer support?",
            answer: "You can contact us by visiting the 'Help Center' or 'Contact Us' at the bottom of the webpage. We’re here to help with anything that concerns you!"
        },
        {
            question: "Where can I learn more about Digital Wardrobe?",
            answer: "You learn more about us through the 'About Us' section at the bottom of the webpage! You can also follow us on all of our social media for more news and updates!"
        },
    ];

    return (
        <div className="faq-section">
            <h1><strong>Frequently Asked Questions (FAQ)</strong></h1>
            <div className="faq-container">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div
                            className="faq-question"
                            onClick={() => toggleQuestion(index)}
                        >
                            {faq.question}
                        </div>
                        {activeIndex === index && (
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
